import { apiRoot } from "../../../old/beheer/store/api/apiRoot.ts";
import { UrlBuilder } from "../../../utils/UrlBuilder.ts";
import _ from "lodash";
import { BaseDocumentObject, ExistingResourceObject, QueryJsonApiIndex } from "../../Products/api/baseTypes.ts";
import { ProductAttributes } from "../../Products/api/productJsonApi.ts";

const optionGroupEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["OptionGroup"],
});

export type OptionGroupAttributes = {
  name: string;
  vestiging_id: number;
  sortkey: number | null;
  apiId: string | null;
  blocked: boolean;
  is_active_in_pos: boolean;
  is_active_in_jamezz: boolean;
  min_count: number;
  max_count: number;
  optionGroupProducts: ExistingResourceObject<ProductAttributes>[];
};

export type FilterFields =
  | "vestiging_id"
  | "option_group_id"
  | "product_id"
  | "apiId"
  | "name"
  | "api_name"
  | "id_api_id_name";

export const optionGroupApi = optionGroupEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    fetchOptionGroups: builder.query<
      BaseDocumentObject<ExistingResourceObject<OptionGroupAttributes>>,
      QueryJsonApiIndex<FilterFields>
    >({
      query: ({ gridFilterItems, pagination, include }) => {
        return {
          url: new UrlBuilder("option_groups")
            .setPage(pagination?.page)
            .setPerPage(pagination?.perPage)
            .setFilters(_.values(gridFilterItems))
            .addInclude(include).url,
          method: "GET",
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "OptionGroup" as const, id })),
              { type: "OptionGroup", id: "PARTIAL-LIST" },
            ]
          : [{ type: "OptionGroup", id: "PARTIAL-LIST" }],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useLazyFetchOptionGroupsQuery, useFetchOptionGroupsQuery } = optionGroupApi;
